import type { VehicleType } from '@/api/types';

const OPTIONS: { value: VehicleType; icon: string; label: string }[] = [
  { value: 'PEDESTRIAN', icon: '🚶‍♂️', label: 'Пешком' },
  // "СИМ" is the legal term for a kick scooter — nobody delivering on one calls it that.
  { value: 'BICYCLE', icon: '🚲', label: 'Вело/самокат' },
  { value: 'CAR', icon: '🚗', label: 'Авто' },
];

interface Props {
  value: VehicleType;
  onChange: (v: VehicleType) => void;
}

export function VehiclePicker({ value, onChange }: Props) {
  return (
    <div className="vehicle-row" role="radiogroup" aria-label="Транспорт">
      {OPTIONS.map((opt) => (
        <button
          key={opt.value}
          type="button"
          role="radio"
          aria-checked={value === opt.value}
          className={`vehicle-btn${value === opt.value ? ' active' : ''}`}
          onClick={() => onChange(opt.value)}
        >
          <span className="vehicle-icon" aria-hidden>{opt.icon}</span>
          <span>{opt.label}</span>
        </button>
      ))}
    </div>
  );
}
